import { adminPermissions } from './adminPermissions';
import { OrgType, Permission } from '@retail/auth/types';

const brandOrgTypes: OrgType[] = ['RETAIL_BRAND', 'WHOLESALE_BRAND'];

export const priceObserverPermissions: Permission[] = adminPermissions
  .filter((perm) => brandOrgTypes.includes(perm.orgType))
  .filter((perm) => perm.canRead())
  .map(
    (perm) =>
      new Permission({
        ...perm,
        userRole: 'PRICE_OBSERVER',
        actions: ['READ'],
      })
  );
